import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsPreferencesService {
  constructor(private http: HttpService) {}
  changeCommunicationPreferences(body: any): Observable<any> {
    return this.http.post(
      `${environment.url}/changeCommunicationPreferences`,
      body
    );
  }
  getCommunicationPreferences(): Observable<any> {
    return this.http.get(`${environment.url}/getCommunicationPreferences`);
  }
}
